import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import ResumeSubUseForm from "../../../hooks/editor/resumeSubUseForm";
import { useTranslation } from "react-i18next";
import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import VisualSuggest from "../../../Components/SuggestionVisual/SuggestionVisual";
import SectionItemToolbar from "../../../Components/GlobalSectionToolbar/SectionItemToolbar";
import { ResumePopupContext } from "../../../Context/resumePopupContext";

import WorkExperienceItem from "./WorkExperienceItem";

import { Header1, Header3 } from "./Header/Header1";
import { Header2 } from "./Header/Header2";

function WorkExperience(props) {
  const {
    resumeFields,
    sectionId,
    resumeTitleHandler,
    handleEditorChange,
    resumeHandler,
    resumeUpdate,
    dateHandler,
    styles,
    settings,
    contentAdder,
    handleSliderChange,
  } = props;

  const [t, i18n] = useTranslation("common");
  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    setShowSuggestion,
  } = useContext(jsonEditorContext);
  const {
    jobTitle,
    setJobTile,
    suggestionSection,
    setSuggestionSection,
    suggestionIndex,
    setSuggestionIndex,
    setSideBasic,
  } = useContext(ResumePopupContext);

  const { experience } = settings;

  const [focusIndex, setFocusIndex] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [isSelectedFrom, setIsSelectedFrom] = useState(true);
  const [showSuggest, setShowSuggest] = useState(false);

  //UseForm

  const {
    addResumeField,
    handleDelete,
    handleShowSection,
    handleOnDragEnd,
    // sectionTitleUpdate,
    sectionItemMoveUp,
    sectionItemMoveDown,
    sectionPageLayoutUpdate,
    // showHideElements,
  } = ResumeSubUseForm(props.sectionId);

  const [showQuillToolbar, setShowQuillToolbar] = useState(true);

  const changesetShowQuillToolbar = (status) => {
    setShowQuillToolbar(status);
  };

  const innerSectionClick = (e, index) => {
    setSuggestionIndex(index);
    props.changeFocusStyle(props.sectionId, index.toString(), "item");
  };

  useEffect(() => {
    setFocusIndex(false);
  }, []);

  const handleDatePicker = (selected) => {
    if (selected == "from") {
      setIsSelectedFrom(true);
    } else {
      setIsSelectedFrom(false);
    }
    setShowDatePicker(!showDatePicker);
  };

  let headerHtml;
  if (experience.headerStyle == "Header1") {
    headerHtml = Header1;
  } else if (experience.headerStyle == "Header2") {
    headerHtml = Header2;
  } else if (experience.headerStyle == "Header3") {
    headerHtml = Header3;
  } else {
    headerHtml = Header1;
  }

  const WorkExperienceItemsRef = {};
  const handleSuggestion = (job, index) => {
    setShowSuggest(true);
    setSuggestionIndex(index);
  };

  const hideSuggest = () => {
    setShowSuggest(false);
  };
  useEffect(() => {
    if (props.newSectionFocus != props.sectionId) {
      setShowSuggest(false);
      setShowDatePicker(false);
      setIsSelectedFrom(true);
    }
  }, [props.newSectionFocus]);

  return (
    <>
      {resumeFields && resumeFields.show && (
        <>
          <div
            id={`experience-title`}
            className={
              settings && settings.showIcon
                ? "d-flex experience-title title-section "
                : "experience-title title-section"
            }
            style={{
              backgroundColor:
                styles &&
                styles.isTitleBackgroundColor &&
                styles.isTitleBackgroundColor
                  ? styles.sectionTitleColor
                  : "unset",
            }}
          >
            {settings && settings.showIcon && (
              <span
                style={{
                  marginTop: "auto",
                  color: styles.secondaryColor,
                }}
              >
                <i
                  className="fa fa-briefcase pr-2"
                  aria-hidden="true"
                  style={{
                    fontSize: styles.titleFontSize,
                  }}
                ></i>
              </span>
            )}
            <ContentEditable
              sectionId={sectionId}
              name="customTitle"
              index="0"
              tagType="h5"
              className="section-title"
              value={
                resumeFields.customTitle
                  ? t(`customTitle`, {
                      customTitle: resumeFields.customTitle,
                    })
                  : t(`experience.defaultTitle`)
              }
              placeholder="Title"
              style={{
                color: styles.primaryColor,
                fontFamily: styles.titleFont,
                fontSize: styles.titleFontSize,
                fontWeight: styles.bold,
              }}
              onChange={resumeTitleHandler}
              onBlur={resumeUpdate}
            />
          </div>
          <div className="section-item-wrapper experience-item-wrapper">
            {resumeFields &&
              resumeFields.data &&
              resumeFields.data.map((response, index, row) => (
                <div
                  key={`workexperience-item${index}`}
                  ref={(ref) => (WorkExperienceItemsRef[index] = ref)}
                  className={`experience-item resume-item ${
                    props.newSectionFocus == props.sectionId &&
                    props.currentStateFocus == "item" &&
                    props.newItemFocus &&
                    props.newItemFocus == index.toString()
                      ? "sectionFocusStyle"
                      : ""
                  }`}
                  id={`experience-${index}`}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    innerSectionClick(e, index);
                  }}
                >
                  {showQuillToolbar &&
                    props.newSectionFocus == props.sectionId &&
                    props.currentStateFocus == "item" &&
                    props.newItemFocus &&
                    props.newItemFocus == index.toString() && (
                      <>
                        <SectionItemToolbar
                          index={index}
                          indexString={index.toString()}
                          handleDelete={props.handleItemDelete}
                          sectionItemMoveUp={props.sectionItemMoveUp}
                          sectionItemMoveDown={props.sectionItemMoveDown}
                          addAdditionalField={props.addAdditionalField}
                          row={row}
                          sectionId={props.sectionId}
                          newSectionFocus={props.newSectionFocus}
                          startFrom={response.startFrom}
                          endUntil={response.endUntil}
                          resumeUpdate={resumeUpdate}
                          dateHandler={dateHandler}
                          response={response}
                          changeSettings={props.changeSettings}
                          showDatePicker={showDatePicker}
                          isSelectedFrom={isSelectedFrom}
                          className="ql-bold"
                          handleSliderChange={handleSliderChange}
                        />
                      </>
                    )}

                  {showQuillToolbar &&
                    props.newSectionFocus == props.sectionId &&
                    props.currentStateFocus == "item" &&
                    props.newItemFocus &&
                    props.newItemFocus == index.toString() && (
                      <p
                        className="suggestion-text-experience"
                        onClick={() =>
                          handleSuggestion(response.position, index)
                        }
                      >
                        Show Suggestions
                        <i
                          class="fa fa-plus-circle basic-suggestion-add-icon"
                          aria-hidden="true"
                        ></i>
                      </p>
                    )}
                  {showSuggest &&
                    showSuggest &&
                    props.newSectionFocus == props.sectionId &&
                    props.newItemFocus == index.toString() && (
                      <VisualSuggest
                        job={response.position}
                        sectionId={props.sectionId}
                        index={index}
                        hideSuggest={hideSuggest}
                        showSuggest={showSuggest}
                        contentAdder={contentAdder}
                      />
                    )}
                  {
                    <WorkExperienceItem
                      headerHtml={headerHtml}
                      styles={styles}
                      resumeHandler={resumeHandler}
                      resumeUpdate={resumeUpdate}
                      response={response}
                      index={index}
                      handleDatePicker={handleDatePicker}
                      handleEditorChange={handleEditorChange}
                      changesetShowQuillToolbar={changesetShowQuillToolbar}
                      showQuillToolbar={showQuillToolbar}
                      sectionId={props.sectionId}
                    />
                  }
                </div>
              ))}
          </div>
        </>
      )}
    </>
  );
}

export default WorkExperience;
